/**
 * Banner boven het rooster voor een wijziging die de hele dag raakt — scenario 12
 * uit docs/vragenlijst.md (bijvoorbeeld een projectdag of studiedag).
 *
 * Zo'n activiteit past niet in één lesregel: hij beslaat meerdere lesuren en zou
 * als kaart tussen de lessen de verkeerde indruk geven. De backend haalt hem
 * daarom uit de lessenlijst en levert hem apart aan.
 */
import type { Dagbanner as DagbannerData } from '../types';
import { Icoon } from './Icoon';

export function Dagbanner({ banner }: { banner: DagbannerData }) {
  const sub = [
    banner.toelichting,
    banner.van ? `${banner.van} – ${banner.tot}` : '',
    banner.lokalen.length > 0 ? banner.lokalen.join(', ') : '',
  ].filter(Boolean);

  return (
    <div className="day-banner">
      <Icoon naam="speld" />
      <div>
        <div className="titel">{banner.titel}</div>
        <div className="toelichting">{sub.join(' · ')}</div>
      </div>
    </div>
  );
}
